/**
 * @desc 封装一个操作<a/>
 * @props text: string,                    // 操作的文案
 * @props allow?: string | undefined,      // 需要的权限
 * @props onClick?: () => void,            // 点击后的操作
 * @props lubanId?: string | undefined,    // 埋点
 * @props isLink?: boolean,                // 是链接还是文字 true 链接； false 文字；
 * @props restProps?: object,              // 如果是链接的话 可以传其他的属性给<a/>
 * @props style?: object,                  // 如果是链接的话 样式
 * @props className?: string,              // 如果是链接的话 类名
 */
import React from 'react';
import Authorized from '../../components/Auth/auth';
import styled from 'styled-components';
const A = styled.a `
  &:before {
    content: ' ';
    ${(props) => {
    return props.iconImg ? {
        content: '',
        display: 'inline-block',
        width: '16px',
        height: '14px',
        margin: '1px 8px 0 0',
        backgroundImage: props.iconImg,
        backgroundSize: '100% 100%',
    } : {
        content: 'none',
    };
}};
    ${(props) => props.iconStyle}
  }
`;
export default function optLink(props) {
    const { allow, onClick = () => { }, lubanId, text, isLink = true, style = {}, className = '', restProps = {}, iconImg, iconStyle = {}, } = props;
    return isLink ? (<Authorized allow={allow}>
      <A className={className} style={style} onClick={onClick} luban-id={lubanId} {...restProps} iconImg={iconImg} iconStyle={iconStyle}>
        {text}
      </A>
    </Authorized>) : text;
}
